<div class="row contrast-container product-detail" *ngIf="product != null; else loading">
  <div class="col-xs-12 col-sm-6">
    <span class="favourite-icon-wrapper">
      <lib-favourite-product-icon [id]="product.id"></lib-favourite-product-icon>
    </span>
    <lib-product-details-image-carousel
      *ngIf="product"
      [openExternal]="false"
      [zoom]="false"
      [images]="product.extra.images"
      imageSize="500x500"
      [highRes]="true"
      [imageColorFill]="''"
      [model3dFile]="model3dFiles"
    />
  </div>
  <div class="col-xs-12 col-sm-6">
    <h5 class="m-0">
      @if (!isStandardErp) {
        {{ product.id }}
      } @else {
        {{ product.extra?.gme?.displayId }}
      }
    </h5>
    <h1 class="mt-0">{{ product.name }}</h1>
    <p
      [innerHTML]="
        product.extra?.i18n?.[currentLang]?.description ||
          concept?.extra?.i18n?.[currentLang]?.description ||
          product.extra?.pim?.description ||
          product.description ||
          '' | safeHtml
      "
    ></p>

    <div class="row">
      @if (availability) {
        <div class="col-12">
          <i class="fas fa-box"></i>&nbsp;
          <lib-availability [availability]="availability" [isSales]="isSales" [product]="product"></lib-availability>
        </div>
      }
      <div class="col">
        @if (
          priceConfigService.productDetailV2NetGrossPriceDisplay &&
          price?.customerDiscountPercent &&
          !environment?.displayPriceLevels
        ) {
          <h4>
            <div class="d-flex flex-row flex-wrap justify-content-between">
              <lib-price
                [price]="price"
                type="customerNetPrice"
                class="mr-2"
                [priceLevelsDisplayType]="'FULL'"
              ></lib-price>
              <span class="text-muted">
                <lib-price [price]="price" type="customerGrossPrice"></lib-price>
                <small> (-{{ price.customerDiscountPercent }}%)</small>
              </span>
            </div>
          </h4>
        } @else {
          <h4>
            <!-- <span>{{ 'NET_PRICE' | translate }}</span>: -->
            <strong>
              @if (!isStandardErp) {
                <lib-price [price]="price" type="customerNetPrice" [priceLevelsDisplayType]="'FULL'"></lib-price>
              } @else {
                <span
                  ><lib-price [price]="price" type="customerGrossPrice" [priceLevelsDisplayType]="'FULL'"></lib-price>
                  @if (price?.customerDiscountPercent) {
                    (-{{ price.customerDiscountPercent }}%)
                  }
                </span>
              }
            </strong>
          </h4>
        }
      </div>
    </div>

    @if (!isAnonymous && !isOnlyDisplayFlow) {
      <div class="product-card-button">
        <lib-buy-button-wrapper [product]="product" [availability]="availability"></lib-buy-button-wrapper>
      </div>
    }

    @if (hasPimPropertiesToShow && hasPimGroupsToShow) {
      <lib-gung-accordion-pim-data-templates [product]="product" [extraProperties]="extraProperties" />
    } @else {
      <lib-gung-accordion>
        <lib-gung-accordion-item *ngIf="hasPimPropertiesToShow" [collapsed]="false">
          <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAILS' | translate }}</ng-template>
          <ng-template libGungAccordionBody>
            <lib-cloud-pim-product-fields [product]="product"></lib-cloud-pim-product-fields>
          </ng-template>
        </lib-gung-accordion-item>
        <lib-gung-accordion-item *ngIf="visibleDocuments?.length > 0">
          <ng-template libGungAccordionHeader>{{ 'DOCUMENTS' | translate }}</ng-template>
          <ng-template libGungAccordionBody>
            <div class="table-responsive">
              <table class="table table-hover table-borderless table-striped table-sm">
                <thead>
                  <tr>
                    <th translate>CATEGORY</th>
                    <th class="text-right" translate>DOWNLOAD_DOCUMENT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let document of this.visibleDocuments">
                    <td>
                      {{
                        metadataService.getMetadataValue('documentType', 'description', document.extra.documentType) ||
                          document.i18n[currentLang]?.description ||
                          document.category
                      }}
                    </td>
                    <td class="text-right">
                      <a target="_blank" [href]="document | gungDownloadUrl">
                        <span translate>{{ document?.s3Uri?.split('/')?.reverse()[0] || 'DOCUMENT' }}</span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
    }
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div *ngIf="product?.extra.pim?.relatedProducts">
      <h3 class="mb-0 mt-3" translate>RELATED_PRODUCTS</h3>
      <lib-product-list-by-ids [productIds]="product?.extra.pim?.relatedProducts"></lib-product-list-by-ids>
    </div>
  </div>
</div>

<ng-template #cloudPimFields>
  <lib-cloud-pim-product-fields [product]="product"></lib-cloud-pim-product-fields>
</ng-template>
<ng-template #nan></ng-template>
<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</ng-template>
